import { createSelector } from '@reduxjs/toolkit'

const subscriptionData = (state) => state.subscription

export const selectSubscriptionData = createSelector([subscriptionData], (subscription) => subscription)
